import config from 'lib/config';

let initialized = false;

const conversionIds = [
  config.googleAdwordsConversionIdNew,
  config.googleAdwordsConversionIdOld,
];

function send() {
  window.dataLayer = window.dataLayer || [];
  // For some reason this only works with Arguments object
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

function initialize() {
  send('js', new Date());
  // https://developers.google.com/adwords-remarketing-tag/#configuring_the_global_site_tag_for_multiple_accounts
  conversionIds.forEach((conversionId) => send('config', conversionId));
  initialized = true;
}

function gtag(...args) {
  if (!initialized) {
    initialize();
  }
  send(...args);
}

function sendToParams() {
  return conversionIds.map((id) => `AW-${id}`);
}

function track(params = {}) {
  const eventParams = params.eventParams || {};
  eventParams.send_to = sendToParams();
  gtag('event', params.eventName, eventParams);
}

// eslint-disable-next-line import/prefer-default-export
export function trackHomepageView() {
  track({ eventName: 'page_view', eventParams: { dynx_pagetype: 'home' } });
}

export function trackListingsView(vins) {
  track({
    eventName: 'page_view',
    eventParams: { dynx_itemid: vins, dynx_pagetype: 'searchresults' },
  });
}

export function trackVdpView(vin) {
  track({
    eventName: 'page_view',
    eventParams: { dynx_itemid: vin, dynx_pagetype: 'offerdetail' },
  });
}

export function trackContactFormClick(listingId) {
  track({
    eventName: 'contact_form_click',
    eventParams: { listingId },
  });
}

export function trackFavorite(vin) {
  track({
    eventName: 'favorite_click',
    eventParams: { dynx_itemid: vin },
  });
}

export function trackConversion(vin, cpl, geolocation, listingId, price) {
  const eventParams = {
    dynx_itemid: vin,
    dynx_pagetype: 'conversion',
    currency: 'USD',
    value: cpl,
    listingId: [listingId],
    price,
    dynx_conversion_id: `${new Date().getTime()}.${Math.random()
      .toString(36)
      .substring(5)}`,
  };
  eventParams.send_to = sendToParams();

  if (geolocation) {
    eventParams.dynx_locid = `${geolocation.latitude},${geolocation.longitude}`;
  }

  gtag('event', 'conversion', eventParams);

  gtag('event', 'conversion', {
    ...eventParams,
    send_to: 'AW-1041740404/OMlfCLKGm50BEPTk3vAD',
  });
}

export function addedToFavorites(vin) {
  track({
    eventName: 'add_to_wishlist',
    eventParams: { dynx_itemid: vin, dynx_pagetype: 'conversionintent' },
  });
}

export default {
  trackHomepageView,
  trackConversion,
  trackListingsView,
};
